import React from "react";
import DirectoryTable from "@/components/DirectoryTable";
import { useAuth } from "@/context/AuthContext";
import { hasRole } from "@/lib/utils";

const FIELDS = [
  { name: "name", label: "Infra Item Name", required: true },
  { name: "type", label: "Type", type: "select", options: ["Cloud", "On-prem", "GPU", "CPU"] },
  { name: "specs", label: "Specs", type: "textarea" },
];

const COLUMNS = [
  { key: "name", label: "Infra Item" },
  { key: "type", label: "Type" },
  { key: "specs", label: "Specs" },
];

export default function AdminInfra() {
  const { user } = useAuth();
  return (
    <DirectoryTable
      title="Nexus Infra Catalog"
      description="Infrastructure items owned by Nexus, available as a dropdown on Step 2/5 when infra is provided by Nexus rather than the client."
      endpoint="/infra-catalog"
      columns={COLUMNS}
      fields={FIELDS}
      canWrite={hasRole(user)}
    />
  );
}
